<template>
  <component :class="$style.list" :is="tag">
    <li v-if="$slots.first">
      <slot name="first" />
    </li>
    <li
      v-for="(value, index) in list"
      :key="
        keyName
          ? typeof keyName === 'function'
            ? keyName(value)
            : value[keyName]
          : index
      "
    >
      <slot :index="index" :item="value" :list="list" />
    </li>
    <li v-if="$slots.last">
      <slot name="last" />
    </li>
  </component>
</template>

<script>
export default {
  name: 'List',
  props: {
    keyName: {
      required: false,
      type: [Function, String]
    },
    list: {
      default: () => [],
      required: false,
      type: Array
    },
    tag: {
      default: 'ul',
      type: String
    }
  }
};
</script>

<style module>
.list {
  list-style: none;
  padding: 0 !important;
}
</style>
